/** Page type of the AJAX endpoint that returns the title of the referring page (tx_ajax_delo). */
export const PAGE_TITLE_TYPE = '8345';

/**
 * URL of the page title endpoint. The endpoint reads the referer and language from the request body.
 * index.php is addressed explicitly: a CDN may rewrite the bare site root "/" to "/index.html"
 * (CloudFront default root object on staging), which TYPO3 answers with a 404, and on subpages the
 * PageType route enhancer ignores the unmapped type parameter.
 */
export function buildPageTitleUrl(location: Pick<Location, 'origin'>): string {
	const queryString = new URLSearchParams({ type: PAGE_TITLE_TYPE }).toString();
	return `${location.origin}/index.php?${queryString}`;
}
